"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.resultsDefinition = void 0;
exports.makePvs = makePvs;
const property_1 = require("@genesys/property");
const resultGroupNames = __importStar(require("./result-group-names"));
const resultNames = __importStar(require("./result-names"));
exports.resultsDefinition = [
    {
        sortNo: 10,
        propertyName: resultNames.fanSpeed,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 12,
        propertyName: resultNames.maxFanSpeed,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 14,
        propertyName: resultNames.staticPressure,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 16,
        propertyName: resultNames.totalPressure,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 18,
        propertyName: resultNames.velocityPressure,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 20,
        propertyName: resultNames.systemEffectPressureDrop,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 22,
        propertyName: resultNames.fanShaftMechanicalEfficiency,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 24,
        propertyName: resultNames.fanShaftStaticEfficiency,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 32,
        propertyName: resultNames.shaftPower,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 34,
        propertyName: resultNames.outletVelocity,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 26,
        propertyName: resultNames.fanMechanicalEfficiency,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 28,
        propertyName: resultNames.fanStaticEfficiency,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 30,
        propertyName: resultNames.gridPower,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 36,
        propertyName: resultNames.motorSpeed,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 38,
        propertyName: resultNames.maxMotorSpeed,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 40,
        propertyName: resultNames.motorFrequency,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 42,
        propertyName: resultNames.maxMotorFrequency,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 44,
        propertyName: resultNames.current,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 46,
        propertyName: resultNames.cosPhi,
        group: resultGroupNames.motorAndDriveResults
    }
];
function makePvs(result) {
    let pvs = property_1.PropertyValueSet.Empty;
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.maxFanSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.maxFanSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.staticPressure, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.staticPressure)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.totalPressure, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.totalPressure)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.velocityPressure, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.velocityPressure)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.systemEffectPressureDrop, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.systemEffectPressureDrop)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanShaftMechanicalEfficiency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanShaftMechanicalEfficiency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanShaftStaticEfficiency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanShaftStaticEfficiency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.shaftPower, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.shaftPower)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.outletVelocity, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.outletVelocity)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanMechanicalEfficiency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanMechanicalEfficiency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanStaticEfficiency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanStaticEfficiency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.gridPower, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.gridPower)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.motorSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.motorSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.maxMotorSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.maxMotorSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.motorFrequency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.motorFrequency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.maxMotorFrequency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.maxMotorFrequency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.current, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.current)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.cosPhi, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.cosPhi)), pvs);
    return pvs;
}
//# sourceMappingURL=result-definition.js.map